export default "__VITE_ASSET__BAsXoKPY__"